import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import Images from "../../Assets/Images";
import "./MenuCard.css";
import axios from "axios";
import Api from "../../Api/Api";
import postApi from "../../Api/PostApi";
import { roundOff } from "../../Utils/Utils";
import { FilePenLine, PlusCircle, Trash2, XCircle } from "lucide-react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
function MenuCard() {
  const [category, setCategory] = useState(false);
  const [product, setProdut] = useState(false);
  const [draggedCategory, setDraggedCategory] = useState(null);
  const [draggedProduct, setDraggedProduct] = useState(null);
  const [categoryList, setCategoryList] = useState({
    id: "",
    categoryname: "",
    categorydes: "",
    categoryimg: "",
    categorystatus: true,
  });

  const [productlist, setProductlist] = useState({
    Productcat: "",
    Productname: "",
    Productdes: "",
    Productimg: "",
    Productprice: "",
    Producstatus: true,
  });

  const [items, setItems] = useState([]);
  console.log({ items: items });

  const formattedData = {
    categories: items.map((category) => category.id),
    products: items.reduce((acc, category) => {
      acc[category.id] = category.child
        ? category.child.map((product) => product.id)
        : [];
      return acc;
    }, {}),
  };
  console.log(JSON.stringify(formattedData, null, 2));

  fetch("http://192.168.0.110:8000/api/v1/update-sort-order/", {
    method: "POST",
    headers: {
      Authorization: "Token " + localStorage.getItem("Token"),
    },
    body: JSON.stringify(formattedData),
  }).then((response) => response.json());

  const fetchCategories = () => {
    Api.api("http://192.168.0.110:8000/api/v1/categories/").then((data) =>
      setItems(data)
    );
  };

  useEffect(() => {
    axios.defaults.headers["Authorization"] =
      "Token " + localStorage.getItem("Token", "");
    fetchCategories();
  }, []);

  const handelCategory = () => {
    setCategory(true);
  };
  const handelProduct = () => {
    setProductlist({
      Productcat: "",
      Productname: "",
      Productdes: "",
      Productimg: "",
      Productprice: "",
      Producstatus: true,
    });
    setProdut(true);
  };
  const dataURLtoFile = (dataUrl, filename) => {
    if (!dataUrl || !dataUrl.includes(",")) {
      console.error("Invalid data URL:", dataUrl);
      return null;
    }

    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);

    if (!mimeMatch) {
      console.error("Invalid MIME type in data URL:", dataUrl);
      return null;
    }

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const handelCategorySave = async () => {
    const formData = new FormData();
    formData.append("name", categoryList.categoryname);
    formData.append("description", categoryList.categorydes);
    formData.append(
      "image",
      dataURLtoFile(categoryList.categoryimg, "logo.png")
    );
    formData.append("is_active", categoryList.categorystatus);

    const apiUrl = "http://192.168.0.110:8000/api/v1/categories/";

    const response = await postApi(apiUrl, formData, true);

    setCategory(false);
    fetchCategories();
    setCategoryList("");
  };

  const handelProductSave = async () => {
    const formData = new FormData();
    formData.append("category", productlist.Productcat);
    formData.append("name", productlist.Productname);
    formData.append("description", productlist.Productdes);
    formData.append("image", dataURLtoFile(productlist.Productimg, "logo.png"));
    formData.append("is_active", productlist.Producstatus);
    formData.append("price", productlist.Productprice);
    const apiUrl = "http://192.168.0.110:8000/api/v1/products/";

    const response = await postApi(apiUrl, formData, true);

    fetchCategories();
    setProdut(false);
    setProductlist("");
  };
  const handelCategoryUpdate = async () => {
    const formData = new FormData();
    formData.append("name", categoryList.categoryname);
    formData.append("description", categoryList.categorydes);
    formData.append(
      "image",
      dataURLtoFile(categoryList.categoryimg, "logo.png")
    );
    formData.append("is_active", categoryList.categorystatus);

    const apiUrl = `http://192.168.0.110:8000/api/v1/categories/${categoryList.id}/`;

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: "Token " + localStorage.getItem("Token"),
        },
        body: formData,
      });

      const data = await response.json();
      setCategory(false);
      fetchCategories();
      setCategoryList("");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error updating category:", error);
    }
  };
  const handelUpdate = async (category) => {
    setCategoryList({
      id: category.id,
      categoryname: category.name,
      categorydes: category.description,
      categoryimg: category.image?.startsWith("data:image")
        ? category.image
        : category.image
        ? `${category.image}`
        : "",
      categorystatus: category.is_active,
    });

    setCategory(true);
  };

  const handelproUpdate = async (card) => {
    setProductlist({
      id: card.id,
      Productcat: card.category,
      Productname: card.name,
      Productdes: card.description,
      Productimg: card.image?.startsWith("data:image")
        ? card.image
        : card.image
        ? `${card.image}`
        : "",
      Productprice: card.price,
      Producstatus: card.is_active,
    });

    setProdut(true);
  };

  const handelproductUpdate = async () => {
    const formData = new FormData();
    formData.append("category", productlist.Productcat);
    formData.append("name", productlist.Productname);
    formData.append("description", productlist.Productdes);
    formData.append("image", dataURLtoFile(productlist.Productimg, "logo.png"));
    formData.append("is_active", productlist.Producstatus);
    formData.append("price", productlist.Productprice);
    const apiUrl = `http://192.168.0.110:8000/api/v1/products/${productlist.id}/`;

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: "Token " + localStorage.getItem("Token"),
        },
        body: formData,
      });

      const data = await response.json();
      fetchCategories();
      setProdut(false);
      setProductlist("");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error updating category:", error);
    }
  };

  const handelStatusUpdate = async (category, state) => {
    const formData = new FormData();
    formData.append("name", category.name);
    formData.append("is_active", state);

    const apiUrl = `http://192.168.0.110:8000/api/v1/categories/${category.id}/`;

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: "Token " + localStorage.getItem("Token"),
        },
        body: formData,
      });

      const data = await response.json();
      fetchCategories();
      setCategory(false);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error updating category:", error);
    }
  };

  const handelStatusProductUpdate = async (card, state) => {
    const formData = new FormData();
    formData.append("name", card.name);
    formData.append("category", card.category);
    formData.append("is_active", state);

    const apiUrl = `http://192.168.0.110:8000/api/v1/products/${card.id}/`;

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: "Token " + localStorage.getItem("Token"),
        },
        body: formData,
      });

      const data = await response.json();
      fetchCategories();
      setCategory(false);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error updating category:", error);
    }
  };

  const handelCategoryDelete = async (categoryName) => {
    try {
      const apiUrl = `http://192.168.0.110:8000/api/v1/categories/${categoryName}/`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("Token", ""),
        },
      });

      if (response.ok) {
        fetchCategories();
      }
      setItems((prevItems) =>
        prevItems.filter((item) => item.name !== categoryName)
      );
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };
  const handelProductDelete = async (categoryName) => {
    try {
      const apiUrl = `http://192.168.0.110:8000/api/v1/products/${categoryName}/`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("Token", ""),
        },
      });

      if (response.ok) {
        fetchCategories();
      }
      setItems((prevItems) =>
        prevItems.filter((item) => item.name !== categoryName)
      );
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleCategoryDragStart = (index) => {
    setDraggedCategory(index);
  };

  const handleCategoryDragOver = (index, e) => {
    e.preventDefault();
  };

  const handleCategoryDrop = (index) => {
    if (draggedCategory === null) return;

    const updatedItems = [...items];
    const movedCategory = updatedItems.splice(draggedCategory, 1)[0];
    updatedItems.splice(index, 0, movedCategory);

    setItems(updatedItems);
    setDraggedCategory(null);
  };

  const handleProductDragStart = (categoryIndex, productIndex) => {
    setDraggedProduct({ categoryIndex, productIndex });
  };

  const handleProductDragOver = (e) => {
    e.preventDefault();
  };

  const handleProductDrop = (categoryIndex, productIndex) => {
    if (!draggedProduct) return;

    const updatedItems = [...items];
    const draggedCategory = updatedItems[draggedProduct.categoryIndex];
    const targetCategory = updatedItems[categoryIndex];

    const movedProduct = draggedCategory.child.splice(
      draggedProduct.productIndex,
      1
    )[0];

    targetCategory.child.splice(productIndex, 0, movedProduct);

    setItems(updatedItems);
    setDraggedProduct(null);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCategoryList((prev) => ({ ...prev, categoryimg: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleproductFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProductlist((prev) => ({ ...prev, Productimg: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div>
      <SideBar />
      <Header value={{ name: "Menu Card" }} />
      <div className="menu-card-con">
        <div className="menu-card">
          <div>
            <img src={Images.logo_bg} alt="" />
          </div>

          <div className="btn-cont">
            <button className="btn-continue-login m-2" onClick={handelCategory}>
              {" "}
              <PlusCircle size={20} />
              Category
            </button>
            <button className="btn-continue-login m-2" onClick={handelProduct}>
              {" "}
              <PlusCircle size={20} />
              Product
            </button>
          </div>
          <hr style={{ color: "black" }} />
          <div>
            {items.map((category, categoryIndex) => (
              <div
                key={categoryIndex}
                className="menu-cont-card"
                draggable
                onDragStart={() => handleCategoryDragStart(categoryIndex)}
                onDragOver={(e) => handleCategoryDragOver(categoryIndex, e)}
                onDrop={() => handleCategoryDrop(categoryIndex)}
              >
                <div className="menu-card-content">
                  <div className="menu-card-heading">
                    <div className="menu-card-left">
                      <img
                        src={category.image}
                        alt="Category Image"
                        className={`category-img ${
                          !category.is_active ? "bw-image" : ""
                        }`}
                      />
                      <h1>{category.name}</h1>
                    </div>
                    <div className="menu-card-actions">
                      <Trash2
                        onClick={() => handelCategoryDelete(category.id)}
                      />
                      <FilePenLine onClick={() => handelUpdate(category)} />
                      <label className="toggle-switch">
                        <input
                          type="checkbox"
                          checked={category.is_active}
                          onChange={(event) =>
                            handelStatusUpdate(category, event.target.checked)
                          }
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>

                  {/* Child Products */}
                  {category.child.map((card, productIndex) => (
                    <div
                      className="inner-card mt-3"
                      key={productIndex}
                      draggable
                      onDragStart={() =>
                        handleProductDragStart(categoryIndex, productIndex)
                      }
                      onDragOver={handleProductDragOver}
                      onDrop={() =>
                        handleProductDrop(categoryIndex, productIndex)
                      }
                      style={{
                        padding: "10px",
                        margin: "5px 0",
                        cursor: "grab",
                        borderRadius: "5px",
                      }}
                    >
                      <img
                        src={card.image}
                        alt={card.name}
                        className={`burger-img ${
                          !(card.is_active && category.is_active)
                            ? "bw-image"
                            : ""
                        }`}
                      />

                      <div className="inner-card-content">
                        <h2>{card.name}</h2>
                        <p>{card.description}</p>
                        <p className="price "> ₹{roundOff(card.price)}</p>
                        <div className="menu-card-actions">
                          <Trash2
                            onClick={() => handelProductDelete(card.id)}
                          />
                          <FilePenLine onClick={() => handelproUpdate(card)} />
                          <label className="toggle-switch">
                            <input
                              type="checkbox"
                              checked={card.is_active}
                              onChange={(event) =>
                                handelStatusProductUpdate(
                                  card,
                                  event.target.checked
                                )
                              }
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="menu-card-preview">
          <iframe src="https://www.falconsqr.com/" scrolling="no"></iframe>
        </div>
      </div>

      {category && (
        <div className="fixed-cat">
          <div className="fixed-cat-header">
            <h3>Create Category</h3>
            <XCircle className="cross" onClick={() => setCategory(false)} />
          </div>
          <input
            type="text"
            value={categoryList.id}
            onChange={(e) =>
              setCategoryList({ ...categoryList, id: e.target.value })
            }
            hidden
            placeholder="Enter Your Category"
          />
          <hr />
          <label>Name</label>
          <input
            type="text"
            value={categoryList.categoryname}
            onChange={(e) =>
              setCategoryList({ ...categoryList, categoryname: e.target.value })
            }
            placeholder="Enter Your Category"
          />
          <label>Description</label>
          <input
            type="text"
            value={categoryList.categorydes}
            onChange={(e) =>
              setCategoryList({ ...categoryList, categorydes: e.target.value })
            }
            placeholder="Enter Your Description"
          />
          <label>Image</label>
          <input type="file" id="fileInput" onChange={handleFileChange} />
          {categoryList.categoryimg && (
            <img
              src={categoryList.categoryimg}
              alt="Category"
              width="100"
              height="100"
            />
          )}

          <label>Status</label>
          <label className="switch">
            <input
              type="checkbox"
              checked={categoryList.categorystatus}
              value={categoryList.categorystatus}
              onChange={(e) =>
                setCategoryList({
                  ...categoryList,
                  categorystatus: e.target.checked,
                })
              }
            />

            <span class="slider round"></span>
          </label>
          <div className="btn-save-con">
            <button
              className="btn-save"
              onClick={
                categoryList.id ? handelCategoryUpdate : handelCategorySave
              }
            >
              {categoryList.id ? "Update" : "Save"}
            </button>
          </div>
        </div>
      )}

      {product && (
        <div className="fixed-cat">
          <div className="fixed-cat-header">
            <h3>Create product</h3>
            <XCircle className="cross" onClick={() => setProdut(false)} />
          </div>

          <hr />
          <label>Category</label>
          <select
            name="category"
            value={productlist.Productcat}
            onChange={(e) =>
              setProductlist({ ...productlist, Productcat: e.target.value })
            }
          >
            <option value="">Select a category</option>
            {items.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
          <label>Name</label>
          <input
            type="text"
            value={productlist.Productname}
            onChange={(e) =>
              setProductlist({ ...productlist, Productname: e.target.value })
            }
            placeholder="Enter Your product"
          />
          <label>Description</label>
          <input
            type="text"
            value={productlist.Productdes}
            onChange={(e) =>
              setProductlist({ ...productlist, Productdes: e.target.value })
            }
            placeholder="Enter Your Description"
          />
          <label>Image</label>
          <input type="file" onChange={handleproductFileChange} />
          {productlist.Productimg && (
            <img
              src={productlist.Productimg}
              alt="Category"
              width="100"
              height="100"
            />
          )}
          <label>Price</label>
          <input
            type="text"
            value={productlist.Productprice}
            onChange={(e) =>
              setProductlist({ ...productlist, Productprice: e.target.value })
            }
            placeholder="Enter Your Price"
          />
          <label>Status</label>
          <label className="switch">
            <input
              type="checkbox"
              checked={productlist.Producstatus}
              value={productlist.Producstatus}
              onChange={(e) =>
                setProductlist({
                  ...productlist,
                  Producstatus: e.target.checked,
                })
              }
            />

            <span class="slider round"></span>
          </label>
          <div className="btn-save-con">
            <button
              className="btn-save"
              onClick={productlist.id ? handelproductUpdate : handelProductSave}
            >
              {productlist.id ? "Update" : "Save"}
            </button>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default MenuCard;
